import axios from 'axios'
import store from '@/store'
import baseUrl from '@/request/base.js'
import { baseconfig } from "@/config.js";
// 路径        文件格式   参数   文件名
export const downloadFile = (url, ext, params, extname) => {
  const token = store.getters.token
  const adminToken = store.getters.adminID
  return  new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${baseUrl.basic}${url}`,
      params: params,
      headers: {
        'Authorization': token,
        'AdminToken': adminToken,
        'v': baseconfig.v
      },
      responseType: 'blob', //二进制流
    }).then(res => {
      const resData = res.data
      const fileReader = new FileReader()
      fileReader.onloadend = () => {
        // 方法二：
        if (resData.type === 'application/json' || resData.type==="text/plain") {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          // 后台信息
          reject(jsonData)
        } else {
          // 下载文件
          // 处理返回的文件流
          const content = res;
          const blob = new Blob([content.data], { type: 'application/vnd.ms-excel;charset=utf-8' });
          var myDate = new Date();
  
          //文件名 extname
          const fileName = extname + myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate() + "." + ext;
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
          resolve({code:100})
        }
      }
      fileReader.readAsText(resData)
    });
  }) 
};
//导出
export const getRecordExport = (url, ext, params, extname) => {
  //                          路径        文件格式   参数   文件名
  // return downloadFile('/record/export',"xlsx", params,extname)
  return downloadFile(url, ext, params, extname)
}